class FacebookBusinessAccount {
  public readonly id: FacebookBusinessAccountId;
  public readonly name: string;

  constructor({ id, name }: { id: FacebookBusinessAccountId; name: string }) {
    this.id = id;
    this.name = name;
  }

  public static fromJSON = (json: any): FacebookBusinessAccount => {
    const obj = { ...json };
    const { id, name } = obj;
    if (typeof id !== 'string') throw new Error('.id must be a string');
    if (typeof name !== 'string') throw new Error('.name must be a string');

    return new FacebookBusinessAccount({
      id,
      name,
    });
  };
}

type FacebookBusinessAccountId = string;

export default FacebookBusinessAccount;
